import { RouteInfo } from './sidebar.metadata';
export function getAlldata2() {
    const lsROUTES: RouteInfo[] = [
    ]

    if (sessionStorage.getItem('claimFinancing') == 'true') {
        lsROUTES.push(

            {
                path: '', title: 'Claim Financing', icon: 'ft-aperture', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [

                    {
                        path: '/Lender/Dahboard/dashBoard', title: 'Dashboard', icon: 'fa fa-tachometer', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },


                    {
                        path: '/Lender/Invoice/Invoice', title: 'Invoice', icon: 'fa fa-hospital-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },


                    {
                        path: '/Lender/Hospital/hospital', title: 'Hospital', icon: 'fa fa-hospital-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Lender/Edit_Profile', title: 'Edit Profile', icon: 'fa fa-pencil-square-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                ]
            },

        )
    }

    if (sessionStorage.getItem('supplierFinancing') == 'true') {
        lsROUTES.push(
            {
                path: '', title: 'Supplier Financing', icon: 'ft-aperture', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [
                    {
                        path: '/Lender/Supplier/Dahboard/Dashboard', title: 'Dashboard', icon: 'fa fa-tachometer', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },

                    {
                        path: '/Lender/Supplier/Invoices/Invoice', title: 'Invoices', icon: 'fa fa-file-text', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Lender/Supplier/Hospital/hospitalList', title: 'Hospital', icon: 'fa fa-hospital-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Lender/Supplier/Edit_Profile/editProfile', title: 'Edit Profile', icon: 'fa fa-pencil-square-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },


                ]
            },

        )
    }
    if (sessionStorage.getItem('purchaseFinancing') == 'true') {
        lsROUTES.push(
            {
                path: '', title: 'Purchase Financing', icon: 'ft-aperture', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [
                    {
                        path: '/Lender/Pharmacy/Dahboard/Dashboard', title: 'Dashboard', icon: 'fa fa-tachometer', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },

                    {
                        path: '/Lender/Pharmacy/Invoices/Invoice', title: 'Invoices', icon: 'ft-aperture', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Lender/Pharmacy/Hospital/hospitalList', title: 'Hospital', icon: 'fa fa-hospital-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Lender/Pharmacy/Edit_Profile/editProfile', title: 'Edit Profile', icon: 'fa fa-pencil-square-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },


                ]
            },

        )
    }

    if (sessionStorage.getItem('patientFinancing') == 'true') {
        lsROUTES.push(
            {
                path: '', title: 'Patient Financing', icon: 'ft-aperture', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [
                    {
                        path: '/Aggregator/Patient/Dashboard/Lender-Dashboard', title: 'Dashboard', icon: 'fa fa-tachometer', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },

                    {
                        path: '/Aggregator/Patient/Invoices/Lender-Invoice', title: 'Invoices', icon: 'ft-aperture', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },


                ]
            },
        )
    }

    return lsROUTES
}





